import React, { useEffect, useState } from "react";
import Script from "next/script";
import { UserProvider } from "../context/UserContext";
import { useRouter } from "next/router";
import SessionExpiredModal from "@/components/Session/SessionExpiredModel";

import "bootstrap/scss/bootstrap.scss";
import "../public/scss/default/euclid-circulara.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "sal.js/dist/sal.css";
import "../public/css/plugins/fontawesome.min.css";
import "../public/css/plugins/feather.css";
import "../public/css/plugins/odometer.css";
import "../public/css/plugins/animation.css";
import "../public/css/plugins/euclid-circulara.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-cards";
import "swiper/css/free-mode";
import "swiper/css/thumbs";

import sal from "sal.js";
import "../public/scss/styles.scss";
import "../public/css/style.css";
import CookiesAccept from "@/components/Cookies/cookies";
import ProtectedRoute from "@/components/ProtectedRoute/ProtectedRoute";
import Layout from "@/components/layout";
import { checkVersion } from "@/utils/checkVersion";


function LoadingSpinner() {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        width: "100vw",
        backgroundColor: "rgba(0,0,0,0.3)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        className="spinner-border text-primary"
        role="status"
        style={{ width: 60, height: 60 }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}

export default function App({ Component, pageProps }) {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [consent, setConsent] = useState("");

  useEffect(() => {
    require("bootstrap/dist/js/bootstrap.bundle.min.js");
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "G-7DYX3TDMZ1");

    const handleStart = (url) => {
      if (url !== router.asPath) {
        setLoading(true);
      }
    };
    const handleComplete = () => setLoading(false);
    const handleError = () => setLoading(false);

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleComplete);
    router.events.on("routeChangeError", handleError);

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleComplete);
      router.events.off("routeChangeError", handleError);
    };
  }, [router]);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    setConsent(consent);

    if (consent === "true") {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", "G-7DYX3TDMZ1");
    }
  }, []);

  useEffect(() => {
    checkVersion();
    const interval = setInterval(() => {
      checkVersion();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;
    document.documentElement.setAttribute(
      "data-theme",
      prefersDark ? "dark" : "light"
    );

    const listener = (e) =>
      document.documentElement.setAttribute(
        "data-theme",
        e.matches ? "dark" : "light"
      );
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", listener);

    return () =>
      window
        .matchMedia("(prefers-color-scheme: dark)")
        .removeEventListener("change", listener);
  }, []);

  return (
    <>
      {consent === "true" && (
        <Script
          src="https://www.googletagmanager.com/gtag/js?id=G-7DYX3TDMZ1"
          strategy="afterInteractive"
        />
      )}

      {loading && <LoadingSpinner />}

      <ToastContainer
        // position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ top: '80px' }}
      />

      <UserProvider>
        <SessionExpiredModal />
        <ProtectedRoute>
          <Layout>
            <Component {...pageProps} />
          </Layout>
        </ProtectedRoute>
      </UserProvider>
    </>
  );
}
